export function initReciteMe({ insertDesktopButton, insertMobileButton } = {}) {
  const serviceUrl = "//au-api.reciteme.com/asset/js?key=";
  const serviceKey = "a2d2b2afc8e09f8c78dfb6b4378841ba910fe3fc";
  const options = {};
  const enableFragment = "#reciteEnable";
  const loaded = [];

  function loadScript(src, callback) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.onload = callback;
    document.head.appendChild(script);
  }

  function getCookie(name) {
    const cookies = document.cookie.split(";").map(c => c.trim());
    const target = cookies.find(c => c.startsWith(name + "="));
    return target ? target.split("=")[1] : null;
  }

  function loadService(callback) {
    const fullUrl = serviceUrl + serviceKey;
    if (loaded.includes(fullUrl)) return;

    loaded.push(fullUrl);
    loadScript(fullUrl, () => {
      if (typeof window._reciteLoaded === "function") window._reciteLoaded();
      if (typeof callback === "function") callback();
      window.Recite.load(options);
      window.Recite.Event.subscribe("Recite:load", () => {
        window.Recite.enable();
      });
    });
  }

  function createButtons() {
    const buttonAlt = 'Recite Me accessibility and Language Support';
    const buttonTitle = 'Launch Recite Me';

    // Desktop Button
    const desktopBtn = document.createElement("div");
    const desktopImg = document.createElement("img");
    desktopBtn.id = "reciteme-desktop";
    desktopBtn.className = "reciteme-button hide-reciteme";
    desktopBtn.title = buttonTitle;
    desktopImg.src = require('../assets/images/reciteme_button_dark.png');
    desktopImg.alt = buttonAlt;
    desktopImg.title = buttonTitle;
    desktopBtn.appendChild(desktopImg);

    // Mobile Button
    const mobileBtn = document.createElement("div");
    const mobileImg = document.createElement("img");
    mobileBtn.id = "reciteme-mobile";
    mobileBtn.className = "reciteme-button hide--reciteme-and-up";
    mobileBtn.title = buttonTitle;
    mobileImg.src = require('../assets/images/reciteme_button_mobile.svg');
    mobileImg.alt = buttonAlt;
    mobileImg.title = buttonTitle;
    mobileBtn.appendChild(mobileImg);

    // Insert Buttons
    if (typeof insertDesktopButton === 'function') {
      insertDesktopButton(desktopBtn);
    }

    if (typeof insertMobileButton === 'function') {
      insertMobileButton(mobileBtn);
    } else {
      document.body.appendChild(mobileBtn);
    }

    // Click handlers
    [desktopBtn, mobileBtn].forEach(btn => {
      btn.addEventListener("click", () => {
        loadService();
        return false;
      });
    });

    // Cleanup on reload
    window._reciteLoaded = () => {
      [desktopBtn, mobileBtn].forEach(btn => {
        if (btn?.parentNode) btn.parentNode.removeChild(btn);
      });
    };
  }

  const persist = getCookie("Recite.Persist");

  if (persist === "true" || window.location.hash === enableFragment) {
    loadService();
  }

  document.addEventListener("DOMContentLoaded", createButtons);
}